<tm-attribute-list-tab-toolbar></tm-attribute-list-tab-toolbar>
<tm-attribute-list-content></tm-attribute-list-content>
